<template>
    <v-container fluid>
        <v-row
            class="mx-0"            
        >
            <v-col
                class="title mt-2"
                cols="8"
            >
                EOD Audits
            </v-col>
        </v-row>
        <v-row
            class="mx-0"            
        >
            <v-col
                cols="12"
                lg="10"
                md="9"
                sm="8"
                xs="12"
                class="company"
            >
                <template v-if="reportMonthandYear">
                    EOD Audits for {{ formatReportDate(reportMonthandYear) }}<v-chip
                        v-if="auditsCount > 0" 
                        class="mx-1"
                        outlined
                        pill
                        small
                    >
                        {{ auditsCount }}
                    </v-chip>
                </template>               
            </v-col>
            <v-col
                cols="12"
                lg="2"
                md="3"
                sm="4"
                xs="12"
            >
                <v-select
                    v-model="reportMonthandYear"
                    :items="CompanyStatsEODAudit"
                    :item-text="'label'"
                    :item-value="'value'"
                    label="Month"
                    outlined
                    dense
                    @change="getCompanyEODAuditsList"
                />
            </v-col>
        </v-row>
        <v-row
            dense
            class="mx-0"
        >
            <v-col>
                <v-data-table
                    id="companyEodListTable"
                    :headers="headers"
                    :items="CompanyEODAuditsList"
                    :items-per-page="itemsPerPage"
                    style="white-space: nowrap;"
                    :loading="loading"
                    loading-text="Loading... Please wait"
                    @update:items-per-page="saveItemPerPage"
                >
                    <template v-slot:[`item.subject`]="{item}">
                        <v-list-item-title>
                            {{ item.subject }}
                            <template>
                                <v-list-item-content>
                                    <v-list-item-subtitle
                                        v-if="item.processed && item.error"
                                        style="color:red;"                                       
                                    >
                                        {{ item.eod_audit_summary }}
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle
                                        v-if="item.processed && !item.error"
                                        style="color:green;"                                       
                                    >
                                        {{ item.eod_audit_summary }}
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle
                                        v-if="!item.processed"
                                        style="color:orange;"                                       
                                    >                                   
                                        {{ item.eod_audit_summary }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </template>                           
                        </v-list-item-title>
                    </template>
                    <template
                       
                        v-slot:[`item.download`]="{item}"
                    >
                        <v-btn
                            v-if="item.processed"
                            icon
                            @click="downloadBtnClick(item)"
                        >
                            <v-icon>mdi-tray-arrow-down</v-icon>
                        </v-btn>
                    </template>                   
                    <template
                        v-slot:[`item.view`]="{item}"
                    >
                        <v-btn
                            v-if="item.processed"
                            icon
                            @click="viewBtnClick(item)"
                        >
                            <v-icon>mdi-eye-outline</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-dialog
            v-model="dialog"
            width="90%"
            :fullscreen="this.$vuetify.breakpoint.xsOnly"
            persistent
        >
            <v-card>
                <v-card-title class="text-h5 lighten-2">
                    <span>{{ eod_audit_summary }}</span>
                    <v-spacer />
                    <v-btn
                        style="text-transform: none !important"
                        depressed
                        @click="dialogCancel"
                    >
                        X
                    </v-btn>
                </v-card-title>
                <v-divider />
                <div
                    class="report-container"
                >
                    <pre>{{ eod_audit }}</pre>
                </div>
                <div :class="{'mobile-download-buttons': !this.$vuetify.breakpoint.smAndUp }">
                    <v-divider />
                    <v-card-actions>
                        <v-spacer v-if="this.$vuetify.breakpoint.smAndUp" />
                        <v-btn
                            style="text-transform: none !important;margin-right: 5px;"
                            depressed
                            color="primary"
                            @click="dialogCancel"
                        >
                            Close
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend';

export default {  
    data: () => ({
        headers: [
            {text: 'Audit', value: 'subject' },
            {text: 'Download', value: 'download', align: 'center',sortable: false, width: '5%' },
            {text: 'View', value: 'view', align: 'center',sortable: false, width: '5%' }
        ],
        reportMonthandYear: '',
        CompanyStatsEODAudit:[],
        CompanyEODAuditsList:[],
        dialog: false,
        eod_audit_summary: '',
        eod_audit: '',
        count: 0,
        loading: false,
        auditsCount: null,
        LocatorLogix: 'Locator LOGiX',        
    }),
    computed: {
        companyName() {
            return this.$store.getters.company.company;
        },
        itemsPerPage() {
            return this.$store.getters.itemsPerPage <= 15 ? this.$store.getters.itemsPerPage : 10;
        },
    },
    
    async mounted() {
        // populate Eod Month with the months and counts; select the first item
        let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
       
        const data = await webtmsBackend.getCompanyStatsEODAudit();
       
        for(let m of data.companyStatsEodAudit) {
            let yearmonth = m.month;
            let count = m.count;
            this.count = count;
           
            let label = months[Number(yearmonth.substring(5)) - 1] + ', ' + yearmonth.substring(0, 4);
            if(yearmonth){
                this.CompanyStatsEODAudit.push({
                    value: yearmonth,
                    month: yearmonth.substring(5),
                    year: yearmonth.substring(0, 4),
                    label: label,
                    count: count
                });
                
            }
        }
        let currentDate = new Date();
        let currentMonth = currentDate.toLocaleString('en-US', { month: '2-digit' });
        let currentYear = currentDate.getFullYear(); 
      
        this.reportMonthandYear = currentYear + '-' + currentMonth;
        this.getCompanyEODAuditsList();
    },
    methods: {
        async getCompanyEODAuditsList() {
            this.auditsCount='';
            this.loading = true;
            try{ 
                this.CompanyEODAuditsList = [];               
                let response = await webtmsBackend.getCompanyEODAuditsList(this.reportMonthandYear);
                this.loading = false;

                for(let list of response.data){ 
                    // Change WEBTMS to Locator LOGiX
                    if(list.eod_audit_summary.indexOf('WEBTMS') > -1){                       
                        list.eod_audit_summary = this.fixWebTms(list.eod_audit_summary);                       
                    }
                    // Change LOOCATOR LOGIX to Locator LOGiX
                    list.eod_audit_summary = this.fixCase(list.eod_audit_summary);

                    if(list.processed && list?.eod_audit_summary.includes(' ERR ')){
                        list.error = true;
                    }
                    this.CompanyEODAuditsList.push(list);
                }
                this.auditsCount = this.CompanyEODAuditsList.length;
            } catch(error) {
                console.error('CompanyEODAuditsList error ', error);
                this.loading = false;
            }
        },       
        async viewBtnClick(item) {
            let response = await webtmsBackend.getCompayEODAudit(item.rowid);
            // Change WEBTMS to Locator LOGiX
            if(response.eod_audit_summary.indexOf('WEBTMS') > -1){                       
                response.eod_audit_summary = this.fixWebTms(response.eod_audit_summary);                       
            }
            // Change WEBTMS to Locator LOGiX
            if(response.eod_audit.indexOf('WEBTMS') > -1){                       
                response.eod_audit = this.fixWebTms(response.eod_audit);                       
            }
            // Change LOOCATOR LOGIX to Locator LOGiX 
            this.eod_audit = this.fixCase(response.eod_audit);
            this.eod_audit_summary = this.fixCase(response.eod_audit_summary);

            this.dialog = true;
        },
        async downloadBtnClick(item) {
            let response = await webtmsBackend.getCompayEODAudit(item.rowid);
            // Change WEBTMS to Locator LOGiX
            if(response.eod_audit_summary.indexOf('WEBTMS') > -1){                       
                response.eod_audit_summary = this.fixWebTms(response.eod_audit_summary);                       
            }

            // Change WEBTMS to Locator LOGiX
            if(response.eod_audit.indexOf('WEBTMS') > -1){                       
                response.eod_audit = this.fixWebTms(response.eod_audit);                       
            }
            // Change LOOCATOR LOGIX to Locator LOGiX
            response.eod_audit_summary = this.fixCase(response.eod_audit_summary); 
            response.eod_audit = this.fixCase(response.eod_audit);

            let reportName = response.eod_audit_summary;
            let report = '<pre>' + response.eod_audit + '</pre>';
            let a = document.createElement('a');
            if (typeof a.download !== 'undefined') a.download = reportName;
            a.href = URL.createObjectURL(new Blob([report], {
                type: 'text/html'
            }));
            a.dispatchEvent(new MouseEvent('click'));
            a.remove();
        },
        dialogCancel(){
            // Close dialog on partent component
            this.dialog = false;
        },       
        formatReportDate(yearmonth) {
            let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
            return months[Number(yearmonth.substring(5)) - 1] + ', ' + yearmonth.substring(0, 4);            
        },
        async getCompayEodAudit(rowid) {
            return await webtmsBackend.getCompayEODAudit(rowid);
        },       
        saveItemPerPage(val) {
            this.$store.dispatch('setItemsPerPage', val);           
        },
        fixWebTms(text) {
            return text.replace('WEBTMS', this.LocatorLogix);
        },
        fixCase(text) {
            return text.replace('LOCATOR LOGIX', this.LocatorLogix);
        }
    },
}
;
</script>
<style>
    #companyEodListTable thead,
    #companyEodListTable th {
        background-color: var(--ll-surface-subtle);
    }
    #companyEodListTable td {
        background: var(--ll-surface);
    }
    .title {
        font-size: 20px;
    }
    .company {
        font-size: 16px;
        font-weight: 500;
    }
    .report-container {
    overflow-y: auto;
    overflow-x: scroll;
    height: calc(100% - 64px);
    padding: 15px;
}   
</style>
